import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import UserModel from './user';
import WellnessInsightsComponentDefinitionModel from './wellness-insights-component-definition';

export default class WellnessTrain extends Model {
  @attr declare wellnessTrain: string;
  @attr declare wellnessTrainRating: number;
  @attr declare wellnessTrainDescription: string;
  @attr declare balanceUpdatedAt: string;
  @attr declare obsUpdatedAt: string;
  @attr declare calculationUpdatedAt: string;
  // TODO: find out what 'actions' is...? this isn't written down anywhere - james 20250725
  // @attr declare actions: unknown; // ?????????
  @attr declare nslds: boolean;
  @attr declare nsldsAsOf: string;
  @attr declare nsldsProcessedAsOf: string;
  @attr declare hasFfelLoans: boolean;
  @attr declare hasDirectLoans: boolean;
  @attr declare hasPerkinsLoans: boolean;
  @attr declare hasParentplusLoans: boolean;
  @attr declare inGracePeriodOrDeferment: boolean;
  @attr declare nonOptimalRepaymentPlan: boolean;
  @attr declare idrRepaymentPlan: boolean;
  @attr declare pslfCountShown: boolean;
  @attr declare idrAnniversaryDate: string;
  @attr declare balanceGoingDown: boolean;
  @attr declare hasRecentForbearance: boolean;
  @attr declare hasDefaultHistory: boolean;
  @attr declare currentlyInDefault: boolean;
  @attr declare pslfFormSubmittedDate: string;
  @attr declare pslfFormSubmitted: boolean;
  @attr declare pslfSubmittedWithin11m: boolean;
  @attr declare pslfSubmittedWithin4m: boolean;
  @attr declare fileType: string;
  @attr declare calc: string;
  @attr declare version: string;
  @attr declare statementBalanceUpdatedAt: string;
  @attr declare statementObsUpdatedAt: string;

  @belongsTo('user', { async: false, inverse: 'wellnessTrain' })
  declare user: UserModel;

  @hasMany('wellness-insights-component-definition', { async: false, inverse: 'wellnessTrain' })
  declare componentDefinitions: WellnessInsightsComponentDefinitionModel[];

  /**
   * the compiler hates overwriting the reload method here and complains that it
   * needs to have the function signature as defined in the ember data model-methods
   * module here:
   * https://github.com/emberjs/data/blob/99d436c83a4aa572ffec88258f2ae669c9b3ff85/packages/model/src/-private/model-methods.ts#L70
   * maybe warp drive will help with this?
   */
  // @ts-expect-error: overriding reload with different return type
  async reload(): Promise<WellnessTrain | null> {
    // wellness trains don't really have meaningful IDs, so look them up based
    // on their associated user since the data comes from a sub-resource of
    // users anyway
    return this.store.queryRecord<WellnessTrain>(WellnessTrain.modelName as never, {
      userId: this.user.id,
    })!;
  }

  get sortedComponentDefinitions() {
    return this.componentDefinitions.slice().sort((a, b) => a.order - b.order);
  }

  get scoreDefinition() {
    return this.componentDefinitions.find((definition) => 'score' === definition.type);
  }

  get summaryDefinition() {
    return this.componentDefinitions.find((definition) => 'dash_summary' === definition.type);
  }

  get accountPromptDefinition() {
    return this.componentDefinitions.find((definition) => 'add_account' === definition.type);
  }

  get recommendationDefinitions() {
    return this.componentDefinitions
      .filter((definition) =>
        [
          'to_coaching',
          'to_pslf_tool',
          'to_idr_tool',
          'to_nslds_upload',
          'to_refinancing_tool',
          'to_strategy_finder',
          'to_pslf_form_submission',
          'transitional_strategy_finder_results',
          'transitional_pslf_form_submission',
          'transitional_pslf_tool_results',
          'transitional_idr_results',
        ].includes(definition.type)
      )
      .sort((a, b) => a.order - b.order);
  }
}
